import { IApplicationState } from '../../types/redux';

export const selectDescription = (state: IApplicationState) => {
  return state.projectData.project.description;
};
